<template>
    <div id="cardSetUp">

      <div class="packagePanel">
		   <h1 class="package-title"><p>卡号：{{recordLoginText}}</p></h1>
            <h1 class="package-title">选择流量包</h1>
            <div class="package" v-for="item in soldPackage" :key="item.id"
            @click="changeState1(item)">
                <span class="label-defined" :class="{'label-defined-active':indexActive==item.id}">
                    <label><van-icon name="success" color="#fff"/></label>
                </span>
                <div class="package-name" :class="{'overlay-package':item.type == 11 ||item.type ==16}"> 
                    <h1 style="color: #07c160;" v-if="item.type == 11||item.type ==16||item.type ==18 ">{{item.packageName?item.packageName:item.name}}</h1>
                    <h1 v-else>{{item.packageName?item.packageName:item.name}}</h1>
					      <p v-if="(item.type==17)">
                        套餐流量30天有效，可跨月使用，有效期内流量不够用，请充值加油包。</p>
						  <p v-else-if="(item.type==18)">
                        有效期：主套餐用完后，请购买此套餐</p>
                        <p v-if="(item.type==20)">
              套餐每30天含100G流量，一年有效，有效期内流量不够用，请充值加油包。 </p>
                </div>
                <div class="package-price" :class="{'overlay-package':item.type == 18 }">
                    <p>优惠价</p>
                    <p>{{item.salePriceRmb?item.salePriceRmb:item.salePrice/100}}元</p>
                </div>
            </div>   
        </div>
        <div class="cardSetUp-middle">
            <h1 style="color:red">*请选择开卡预存费用</h1>
			<div class="package-choose">
            	<div 
            	class="package-choose-item" v-for="(item, index) in packageChoose" :key="index"
            	:class="{'package-item-action': currentItem == index}"
            	@click="changeState(index, item[0], item[1] )">
        			<h1>{{ item[0] }}</h1>
        			<p>到账{{ item[1] }}元</p>
            	</div>
            	
            	<!-- <div class="package-choose-item package-choose-item-defined" 
            	:class="{'package-item-action': currentItem === 999}"
            	@click="showPackageItemDefined(999)"
            	>
        			<h1>自定义</h1>
            	</div> -->

	        </div>
        </div>

        <div class="cardSetUp-action-btn">
            <button @click="btnActionRecharge()">开 户</button>
        </div>
		  <div class="cardSetUp-tip1" v-show="!isWx">
            <p style="color:red"><span></span>开户完成后 请点击实名激活进行认证后，方可使用。</p>
        </div>
        <div class="cardSetUp-action-btn" v-show="!isWx">
            <button @click="btnActionRecharge1()">实名激活</button>
        </div>
        <div class="cardSetUp-tip">
            <p><span>注：</span>开卡前请选择好您要购买的套餐，缴费成功后套餐立即生效，预存费用减去您选择套餐的剩余部分，可用于以后套餐充值使用。</p>
        </div>


        <div class="checkstand-defined" v-show="popup" >
	        <div class="van-overlay" style="z-index:91;" @click="closePopup()"></div>
	        <div class="checkstand-defined-popup" >
	        	<van-icon name="close" size='24' color="#dc4d4d"
	        	class="close-icon" @click="closePopup()"/>
		        <h1>请输入金额</h1>
		        <van-divider />
		        <div class="input-defined">
		        	<span>￥</span>
				  	<van-field
					  readonly
					  placeholder="点此输入"
					  clickable
					  :value="definedPrice"
					  @touchstart.native.stop="showKeyboard = true"
					/>
				</div>
	        	
	        	<div class="btn-defined">
	        		<button @click="btnActionRechargeDefined()"> 充 值 </button>
	        	</div>
	        	

	    	</div>

	    	<van-number-keyboard
			  :show="showKeyboard"
			  v-model="definedPrice"
			  theme="custom"
			  extra-key="."
			  close-button-text="完成"
			  @blur="showKeyboard = false"
			/>
	    </div>






	    <!-- 修改密码框   -->
	    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
	    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-cardSetUp" 
	        style="z-index: 2000; min-height: 25%; min-width: 80%;"
	        v-show="showPasswordPanel"
	        :style="{top:passwordPanelTop+'%'}"
	    >   

	    	<van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
	        
	        <!-- 密码输入框 -->
	        <p>设置开户支付密码：</p>
	        <van-password-input
	          :value="password"
	          :focused="passwordKeyboard"
	          @focus="passwordOnfocus()"
	        />

	        <!-- 再次确认密码输入框 -->
	        <p>再次确认开户密码：</p>
	        <van-password-input
	          :value="confirmPassword"
	          :focused="confirmPasswordKeyboard"
	          @focus="confirmPasswordOnfocus()"
	        />
	        <div class="confirmChangePassword">
	          <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToRecharge()">确 定</van-button>
	        </div>
	        
	    </div>

	    <!-- 数字键盘 -->
	    <van-number-keyboard
	      :z-index="2015"
	      :show="passwordKeyboard"

	      @input="passwordOnInput"
	      @delete="passwordOnDelete"
	      @blur="passwordKeyboard = false"
	    />

	    <van-number-keyboard
	      :z-index="2015"
	      :show="confirmPasswordKeyboard"

	      @input="confirmPasswordOnInput"
	      @delete="confirmPasswordOnDelete"
	      @blur="confirmPasswordKeyboard = false"
	    />
	    <!-- 数字键盘 end -->
	    <!-- 修改密码框 end  -->


        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay" 
            :price="price"/>


    </div>
    
</template>
<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest} from '@/api/user.js'
import Checkstand from "@/components/Checkstand";

export default {
    data(){
        return {
			isWx:false,
			recordLoginText:localStorage.getItem('recordLoginText'),
        	flowPkg: 0,
		    flowPkgArray: [],

		    //原始流量套餐包
		    soldPackage: [],
		    isAdmin:'0',

      		iccid:'',
		    packageChoose:[],

		    //设置密码
		    password:'',
		    confirmPassword: "",
		    alreadySetUp: false,
	      	showPasswordPanel: false,
	      	passwordKeyboard : false,
	      	confirmPasswordKeyboard : false,
	      	passwordPanelTop: 50,
		    

		    //当前余额套餐
		    currentItem: 0,
		    price: 0,
		    giftBalance: 0,

		    //自定义金额
		    popup: false,

		    //自定义键盘
		    showKeyboard: false,
      		definedPrice: '',

      		type:'',
			indexActive:'',

      		//收银台
      		dataToPay:{},
      		checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },

        }        
    },
    methods: { 
        
        closePopup(){
        	this.popup = false;
        },
		 changeState1(item){            
            this.indexActive = item.id;
           
        },

        changeState(currentItem, price, giftBalance){
        	this.currentItem = currentItem;
        	this.price = price;
        	this.giftBalance = (giftBalance - price)*100;
        },

        //点击【自定义】时
        showPackageItemDefined(currentItem){
        	this.popup = true;
        	this.currentItem = currentItem;
        	this.price = null;
        	this.giftBalance = 0;
        },

        //唤起收银台
        toCheckStand(){
        	var data = {                
                iccid: this.$store.state.iccid,
                amount: this.price*100,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
                isAdmin : this.isAdmin,
				soldPackageId:this.indexActive,
				isNextMonth :'0',
				payType:20,
				payPrice:'pay_amonts',
				app:'1',
				lsCallBack:'http://webchat.szxxtx.com/#/user/payBack'
            }
            //this.$store.state.showCheckstandSource = 'balanceRecharge';
          //  this.dataToPay = data;
          //  this.$store.state.showCheckstand = true;
		  if(!this.isWx){
			  data.payType=20;
			  data.app='app';
		  }
			wxRequest("order/user/create/investOrder", data, "post").then(res => {
				if(res.data.code == 200){
					if(data.payType==50){//乐刷
						 window.location.href = res.data.data.jspay_url; 
					}else if(data.payType==20){//微信第三方
						if(this.isWx){
						 var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined"){
                            if( document.addEventListener ){
                                document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                            }else if (document.attachEvent){
                                document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); 
                                document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                            }
                        }else{
                            this.onBridgeReady(param);
                        } 
						}else{
						 window.location.href = res.data.data.mweb_url; 
						}
					} else if(type == 60){//汇付天下
                        let datas = JSON.parse(res.data.data);
                        if (datas.status === 'succeeded') {
                            let payment = datas;
                            AdaPay.doPay(payment, (res) => {
                                Dialog.alert({title: '提示', message: res.result_message});
                                this.cancelPay();
                            })
                        }
                    }
				}else{
					Dialog.alert({message:res.data.message});
				}
            })
			// if(this.isWx){
            //  this.cancelChangePassword();
			// }else{
			// 	 Dialog.alert({title: '提醒', message:'暂时使用微信打开支付！'})
			// }
        },

        //输入完密码后点击 【确定】 时
        sureToRecharge(){
        	if(this.checkPassword()){
        		if(this.type=="recharge"){
	        		this.toCheckStand();
	        	}else if(this.type=="rechargeDefined"){
	        		this.toRechargeDefined();
	        	}
        	}
        },
		   //流量套餐充值时唤起微信支付
        onBridgeReady(param){
            let _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', param,
                function(res){
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){
                        _this.$router.push({
                            path: '/user/payBack', 
                            query:{
                                iccid:_this.$store.state.iccid
                            }
                        }).catch(() => {

                        });
                    } 
                }
            );  
        },
        btnActionRecharge(){
			if(this.indexActive==''){
				Dialog.alert({message:"请选择购买套餐"});
	        	return false;
			}
        	this.type = "recharge";
    		//若当前为自定义状态
        	if(this.currentItem == 999){
        		this.popup = true;
        	}else{
        		this.showPasswordPanel = true;
        	}       
    		        		
        },
		 btnActionRecharge1(){
			let data={
				iccid:this.$store.state.iccid
			}
			   wxRequest("sim/is/have/pkg", data, "get").then(res => {
        if(res.data.code == 200){
           let types= res.data.data;
		   if(types==49){ //联通
				   	this.$router.push({
						path: '/user/cuccAuth',
						query: {
							realNameCard: 1
						}})
			}else if(types==3){ //移动
                 	this.$router.push({
						path: '/user/cmccAuth',
						query: {
							realNameCard: 1
						}})
			}else{
					 this.$router.push({
						path: '/user/ctccAuth',
						query: {
							realNameCard: 1
						}})
			}

        }else{
        	Dialog.alert({message:"请先选择开户，再进行实名激活"});
            }
         });
			
    		        		
        },
        btnActionRechargeDefined(){
        	this.type = "rechargeDefined";

        	if(this.definedPrice < 1){
        		Dialog.alert({message:"金额过低"});
	        	return false;
        	}
        	this.showPasswordPanel = true;
        },

        toRechargeDefined(){
	        let data = {                
                iccid: this.$store.state.iccid,
                amount: this.definedPrice*100 ,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
                isAdmin : this.isAdmin,
            }

            for (let i = this.soldPackage.length - 1; i >= 0; i--) {
    			if(this.soldPackage[i].id == this.flowPkg){
    				data.soldPackageId = this.flowPkg;
	                data.isNextMonth = '0';
    			}
    		}

			this.$store.state.showCheckstandSource = 'balanceRecharge';
            this.dataToPay = data;
            this.$store.state.showCheckstand = true;
			this.price = this.definedPrice;
            this.definedPrice = '';
            this.closePopup();

            this.cancelChangePassword();
    			            
	    },





        /***   修改密码     ***/
	    passwordOnfocus(){
	        this.passwordKeyboard = true;
	        this.confirmPasswordKeyboard = false;
	        this.passwordPanelTop = 30;
	    },
	    passwordOnDelete() {
	      this.password = this.password.slice(0, this.password.length - 1);
	    },

	    passwordOnInput(key) {
	        this.password = (this.password + key).slice(0, 6);
	    },


	    confirmPasswordOnfocus(){
	        this.passwordKeyboard = false;
	        this.confirmPasswordKeyboard = true;
	        this.passwordPanelTop = 30;
	    },
	    confirmPasswordOnDelete() {
	      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
	    },

	    confirmPasswordOnInput(key) {
	        this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
	    },


	    cancelChangePassword(){
	      this.password = '';
	      this.confirmPassword = '';
	      this.passwordPanelTop = 50;
	      this.showPasswordPanel = false;
	    },

	    checkPassword(){
	      if(this.password.length < 6 ){
	      	Dialog.alert({message:"请设置六位支付密码"});
	        return false;
	      }

	      if(this.password!=this.confirmPassword){
	        Dialog.alert({message:"两次输入的新密码不一致"});
	        return false;
	      }
	      return true;
	    },
	    

	    /***   修改密码  end   ***/


    },
    created(){
		this.iccid = this.$store.state.iccid ? 
    	this.$store.state.iccid : 
    	localStorage.getItem('iccid');
		//判断有没有购买过套餐  如果购买过套餐 直接跳转实名页面
		wxRequest("sim/is/have/pkg", {iccid: this.iccid}, "get").then(res => {
             if(res.data.code == 200){
				 if(res.data.data==49){ //联通
					this.$router.push({
						path: '/user/cuccAuth',
						query: {
							realNameCard: 1
						}})
				 }else if(res.data.data==3){ //移动

				 }else{
					 this.$router.push({
						path: '/user/ctccAuth',
						query: {
							realNameCard: 1
						}})
				 }
			 }
        })
	//判断是不是在微信环境中
	var ua = window.navigator.userAgent.toLowerCase();
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
       this.isWx=true;
    } 
    	

    	wxRequest("sim/user/soldPkg/my", {iccid: this.iccid}, "get").then(res => {
            var result = res.data.data;
            if(res.data.code == 200 && result.list.length > 0){
                this.soldPackage = result.list;
                this.isAdmin = result.isAdmin;

                //  流量套餐赋值
                for(let i=0; i<result.list.length; i++){
                	this.flowPkgArray.push({ 
                		text: result.list[i].packageName + 
                		" （ "+result.list[i].salePriceRmb+"元 ）  ",
                		value: result.list[i].id});
                }
                this.flowPkg = this.flowPkgArray[0].value;
				console.log(this.flowPkgArray)
            }
        })

        wxRequest("sim/uniorder/params", {iccid:localStorage.getItem('iccid')}, "post").then(res => {
            if(res.data.code == 200 ){
            	for (let i=0; i < res.data.data.length; i++) {
            		let itme = [res.data.data[i].amount, res.data.data[i].amount+res.data.data[i].giftBalance];
            		this.packageChoose.push(itme);
            	}
            	
            	this.price = this.packageChoose[0][0];
            	this.giftBalance = (this.packageChoose[0][1] - this.packageChoose[0][0])*100;
            }else{
            	Toast.fail(res.data.message);
            }
        })


    },

    mounted() {
        
    },

    beforeDestory(){
       
    }
}
</script>
<style>
	
	#cardSetUp .flowPkg-choose{
		height:36px;
	}
	#cardSetUp .flowPkg-choose .van-dropdown-menu__item{
		padding: 0 10px;
	}

	#cardSetUp .flowPkg-choose .van-dropdown-menu__title{
		display: contents;
	}
	#cardSetUp .flowPkg-choose .van-dropdown-menu__title .van-ellipsis{width: 100%;}
	#cardSetUp .flowPkg-choose .van-dropdown-menu__title::after{
		right: 10px;
	}

	#cardSetUp .flowPkg-choose .van-dropdown-item__content{
		padding: 0 20px;
	}

	#cardSetUp .flowPkg-choose .van-dropdown-item__content .van-cell{
		padding-left: 8px;
		padding-right: 8px;
	}

	#cardSetUp .checkstand-defined-popup .van-field__control{
		font-size: 24px;
	}

	#cardSetUp .checkstand-defined-popup input::-webkit-input-placeholder { 
		/* Chrome/Opera/Safari */ 
		font-size: 14px;
	}
	#cardSetUp .checkstand-defined-popup input::-moz-placeholder { 
		/* Firefox 19+ */  
		font-size: 14px;
	}
	#cardSetUp .checkstand-defined-popup input::-ms-input-placeholder { /* IE 10+ */ 
	 	font-size: 14px;
	}
	#cardSetUp .checkstand-defined-popup input::-moz-placeholder { 
		/* Firefox 18- */ 
		font-size: 14px;
	}

	.changePasswordPanel-cardSetUp [class*=van-hairline]::after{
	    border-color: #c4cedc;
	}

</style>

<style lang="less">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	#cardSetUp{
		background: #F4F3F3;
		height: 100%;

		.cardSetUp-top{
			min-height: 180px;
			padding: 30px 20px 10px 20px;
			margin-bottom: 20px; 
			background: #fff;

			p{
				margin-bottom: 10px;
				padding-left:10px;
				line-height:36px;
				font-size: 16px;
			}

			h1{
				margin-bottom: 10px;
				padding-left:10px;
				font-weight: bold;
			}

			.flowPkg-choose{
				background: #F4F3F3;
			}

		}
		
    .packagePanel {
        padding: 5px 16px;
        background: #fff;
        border-bottom: 10px solid #f5f5f5;

        .package-title{
            padding: 10px 0;
            color: #333;
            font-weight:bold;
        }

        .package{
            display: flex;
            position: relative;
            margin-bottom: 20px;

            .label-defined{
                display: block;
                border-width: 14px 18px 14px 18px;
                border-style: solid;
                border-color: transparent;
                position: absolute;  

                label{
                    position: absolute;
                    left: -14px;
                    top: -12px;
                    background: transparent;
                } 
            }

            .label-defined-active{
                border-color: red transparent transparent red;
            }


            .package-name{
                flex-grow: 1;
                padding: 5px 0 5px 20px;
                border: 1px dashed #FFA941;

                h1{
                    margin: 5px 0;
                    color: #FFA941;
                    font-size: 18px;
                }

                p{
                    margin: 10px 0;
                    color: #333;
                    font-size: 14px;
                }
            }

            .package-name.overlay-package{
                border-color: #07c160;
            }

            .package-price{
                flex-grow: 0;
                width: 80px;
                border: 1px solid #FFA941;

                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                p{
                    margin: 5px 0;
                    color: #fff;
                }
                p:last-child{
                    font-size: 18px;
                }

                background: #FFA941;
            }

            .package-price.overlay-package{
                border-color: #07c160;
                background: #07c160;
            }
            
        }

    }

	


    .toRecharge{
        position: fixed;
        width: 100%;
        bottom: 0;
        font-size: 16px;

        .toRecharge-top{
            background: #F5F5F5;
            display: flex;

            .radio-group-defined{
                display: flex;
                padding-left: 20px;
                justify-content: center;
                align-items: center;
                height: 40px;

                div{
                    height: 20px;
                    margin-right: 15px;
                }
            }

        }

        .detail {
            color: #a0a0a0;
            background: #F5F5F5;
            padding-left: 20px;
            padding-bottom: 5px;
        }

        .toRecharge-bottom{
            display: flex;
            p{
                padding-right: 15px;
                flex-grow: 1;
                color: #333333;
                background:#fff;
                text-align: right;
                line-height: 45px;

                span{
                    color: #FFA941;
                }
            }

            .toRechargeBtn{
                padding: 0 30px;
                display: inline-block;
                line-height: 45px;
                flex-grow: 0;
                color: #fff;
                background: #FFA941;
            }
        }

    }

		.cardSetUp-middle{
			padding: 10px 20px 10px 20px;
			background: #fff;

			h1{
				font-weight: bold;
				line-height: 30px;
				margin-bottom: 10px;
			}

			.package-choose{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				text-align: center;
			}
			
			.package-choose-item{
				height: 60px;
				margin-bottom: 20px;
				flex-basis: 30%;
				border-radius: 5px;
				border:1px solid rgba(255,169,65,1);
				color: #FFA941;

				h1{
					font-weight: 400;
					font-size: 24px; 
					line-height: 40px;
					margin: 0;
				}
			}

			.package-item-action{
				color: #fff;
				background:rgba(255,169,65,1);
			}

			.package-choose-item-defined{
				h1{
					font-size: 20px; 
					line-height: 60px;
				}
			}
		}


		.cardSetUp-action-btn{
			padding: 20px 20px 10px 20px;
			color: #fff;

			button{
				width: 100%;
				line-height: 36px;
				border-radius: 5px;
				background:rgba(255,169,65,1);
				border:0px solid rgba(255,255,255,1);
			}
		}

		.cardSetUp-tip{
			padding: 10px 20px 10px 20px;

			p{
				span{
					color: #FFA941;
				}
				line-height: 20px;
			}
		}
		.cardSetUp-tip1{
			padding: 0px 0px 0px 20px;

			p{
				span{
					color: #FFA941;
				}
				line-height: 20px;
			}
		}

		.checkstand-defined{
			.checkstand-defined-popup{
				position: fixed;
			    background-color: #fff;
			    z-index: 92;
			    width: 80%;
			    min-height: 30%;
			    top: 30%;
			    left: 10%;
			    border-radius: 15px;

			    .input-defined{
			    	padding: 15px 0 0 30px;
			    	border-bottom: 1px solid #ccc;
			    	display: flex;

			    	span{
			    		display: inline-block;
			    		color: #3a3a3a;
			    		font-size: 16px;
			    		line-height: 47px;
			    	}
			    }

			    .btn-defined{
			    	padding:30px 15px 20px 15px;
			    	button{

			    		background:rgba(255,169,65,1);
						border:0px solid rgba(255,255,255,1);
				    	width: 100%;
				    	height: 36px;
				    	color: #fff;
				    	border-radius: 5px;
				    }
			    }
			    

			}

			.close-icon{
				position: absolute;
				right: 5px;
				top: -15px;
			}

			h1{
				margin-top: 5px;
				font-size: 14px;
				line-height: 40px;
				text-align: center;
			}
		}
	}


	.changePasswordPanel-cardSetUp{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
</style>


